var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funding-progress-indicator",class:[`indicator--${_vm.size}`]},[_c('img',{attrs:{"alt":`${_vm.progress}%`,"src":_vm.computedImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }